export const boxStyle = {
    width: "300px",
    height: "300px",
    display: "flex",
    flexFlow: "column",
    justifyContent: "center",
    alignItems: "center"
  };
export  const modalStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  };
export const errorStyle = {
   height: '70vh',
    width: '50vh' 
  }